<template>
<div id="app" class="site container hfeed">
  <HeadNav selectedLanguage="en" page="disclaimer" />

  <div id="content" class="site-content">
    <article class="disclaimer-article">
      <section class="disclaimer-content">
        <header class="disclaimer-header">
          <hh1>Disclaimer</hh1>
        </header>

        <p>
          Welcome to GBWAOnline (the "Website").
        </p>

        <p>
          All the information on this website is published in good faith and for <strong>informational and educational purposes only</strong>. GBWAOnline does <strong>not host or distribute any APK files</strong>. We only share details, reviews, features, and guides about modified app such as <strong>GB WhatsApp</strong> and other WhatsApp Mods.
        </p>

        <p>
          GBWAOnline is <strong>not affiliated, endorsed, or sponsored</strong> by Meta Inc. (the official owner of WhatsApp) or any other third-party developers mentioned on this site.
        </p>

        <p>
          All product names, trademarks, and registered trademarks are property of their respective owners.
        </p>

        <p>
          While we strive to provide accurate and up-to-date content, we make <strong>no warranties</strong> about the completeness, reliability, or accuracy of this information. Any action you take upon the information you find on this website (GBWAOnline) is <strong>strictly at your own risk</strong>. GBWAOnline will not be liable for any losses and/or damages in connection with the use of our website.
        </p>

        <p>
          From our website, you can visit other external websites by following hyperlinks. While we try to provide quality and ethical links, we have <strong>no control</strong> over the <strong>content and nature</strong> of these external sites. Links to other websites do not imply a recommendation for all the content found there. Site owners and content may change without notice.
        </p>

        <p>
          By using our website, you hereby <strong>consent to our disclaimer</strong> and agree to its terms.
        </p>

      </section>
    </article>
  </div>
</div>
</template>

<script>
import '@/css/base.scss';
import '@/css/index.scss';
import HeadNav from '@/components/HeadNav.vue';

export default {
  name: 'Disclaimer',
  components: { HeadNav },
};
</script>

<style scoped>
.disclaimer-article {
  display: block;
}

.disclaimer-content {
  max-width: 900px;
  margin: 2rem auto;
  padding: 24px;
  background: #fff;
  border-radius: 16px;
}

.disclaimer-header {
  text-align: center;
  margin-bottom: 24px;
}

.disclaimer-content p {
  line-height: 1.7;
  color: #495057;
  font-size: 1.1em;
  margin: 16px 0;
}

@media (max-width: 768px) {
  .disclaimer-content {
    padding: 16px;
    margin: 1rem auto;
  }

}
</style>

